import { Divider } from 'antd';
import moment from 'moment';
import editIcon from '../../../../assets/editAdminIcon.svg';
import pendingIcon from '../../../../assets/panding-circle.svg';
import { ClockIcon } from '../../../Icons/ClockIcon';
import './index.scss';
import { CalendarSvg } from '../../../Icons/CalendarIcon';
import stopImage from '../../../../assets/stopImage.svg';
import calendar from '../../../../assets/calendar-chedule.svg';
import calendarImage from '../../../../assets/Calendar, Schedule, Clock.svg';
import messageGrey from '../../../../assets/messageGrey.svg';

export const SupplierCardForTREvaluate2 = ({ elem, setIsEditModal, setSupplierData, setTaskId }: any) => {
    const pitchSlot = elem?.pitch?.assigned_slot;
    const pitchDateDisplay = pitchSlot?.date ? moment(pitchSlot.date).format('YYYY-MM-DD') : '—';
    const pitchTimeDisplay =
        pitchSlot?.time_from && pitchSlot?.time_to ? `${pitchSlot.time_from} - ${pitchSlot.time_to}` : '—';

    const evaluateRejectionReason = elem.comments?.su_rejected_category_name;
    const isRejectedSupplier = elem?.status === 'rejected' && evaluateRejectionReason;

    const isRejectedSlot = elem?.pitch?.status === 'rejected' && evaluateRejectionReason;
    const isRescheduledSlot = elem?.pitch?.status === 'slots_request' && elem?.pitch?.decline_reason;

    return (
        <div className="task-complete__supplier supplier">
            <div className="supplier__header newdesign">
                <div className="supplier-tags">
                    <div className="supplier-tags__left">
                        {elem.added_by_buyer && <span className="tag tag--buyer">Added by buyer</span>}

                        {elem.incumbent && <span className="tag tag--incumbent">Incumbent Supplier</span>}
                    </div>
                </div>
                {elem.status === 'shortlisted' && <div className="supplier-tags__status">Scorecard Completed</div>}
                {elem.status === 'rejected' && (
                    <div className="supplier-tags__status rejected">Excluded from Evaluation</div>
                )}
            </div>
            <div className="supplier__row">
                <div className="supplier__wrap first">
                    <div className="supplier__title">
                        ({elem.name_prefix}) {elem.name}
                    </div>
                    <div className="supplier__subtitle">{elem.trading_name}</div>
                </div>
                {elem.manager_name ? (
                    <div className="supplier__wrap">
                        <div className="supplier__title">{elem.manager_name ? elem.manager_name : ''}</div>
                        <div className="supplier__subtitle">
                            {elem?.email ? elem?.email : ''} {elem?.phone_number ? elem?.phone_number : ''}
                        </div>
                    </div>
                ) : (
                    <div className="supplier__wrap"></div>
                )}

                {elem.manager_name && (
                    <img
                        src={editIcon}
                        className="supplier__delete"
                        onClick={() => {
                            setTaskId(elem.id);
                            setSupplierData({
                                manager: {
                                    name: elem.manager_name,
                                    email: elem.email,
                                    phone_number: elem.phone_number
                                },
                                company: {
                                    name: elem.name
                                },
                                id: elem.id
                            });
                            setIsEditModal(true);
                        }}
                    />
                )}
            </div>
            <Divider style={{ margin: '0' }} />
            <div className="supplier__row supplier-pitch-row">
                {isRescheduledSlot ? (
                    <div className="slots-wrapper row">
                        <div className="slot-block">
                            <span className="slot-label">Pitch Date & Time</span>
                            <div className="slot-value orange">
                                <CalendarSvg fill="#E64A0D" className={''} />
                                New Slot Requested
                            </div>
                        </div>
                        <div className="supplier-pitch-row__status">
                            <img src={pendingIcon} alt="" className="supplier-pitch-row__status-icon" />
                            <span>Pending Completion</span>
                        </div>
                    </div>
                ) : isRejectedSlot ? (
                    <div className="slots-wrapper row">
                        <div className="slot-block">
                            <span className="slot-label">Pitch Date & Time</span>
                            <div className="slot-value error">
                                <img src={stopImage} alt="calendar" />
                                Participation Withdrawn
                            </div>
                        </div>
                        <div className="supplier-pitch-row__status">
                            <img src={pendingIcon} alt="" className="supplier-pitch-row__status-icon" />
                            <span>Pending Completion</span>
                        </div>
                    </div>
                ) : pitchSlot ? (
                    <div className="slots-wrapper row">
                        <div className="slots-wrapper">
                            <div className="slot-block">
                                <span className="slot-label">Pitch Date</span>
                                <div className="slot-value">
                                    <img src={calendar} alt="calendar" />
                                    {moment(pitchSlot?.date)?.format('YYYY-MM-DD')}
                                </div>
                            </div>
                            <div className="slot-block">
                                <span className="slot-label">Time</span>
                                <div className="slot-value">
                                    <ClockIcon fill="#001965" />
                                    {pitchSlot?.time_from} - {pitchSlot?.time_to}
                                </div>
                            </div>
                        </div>{' '}
                        <div className="supplier-pitch-row__status">
                            <img src={pendingIcon} alt="" className="supplier-pitch-row__status-icon" />
                            <span>Pending Completion</span>
                        </div>
                    </div>
                ) : (
                    <div className="slots-wrapper">
                        <div className="slot-block">
                            <span className="slot-label">Pitch Date & Time</span>
                            <div className="slot-value">
                                <img src={calendarImage} alt="calendar" />
                                Not Specified Yet
                            </div>
                        </div>
                    </div>
                )}
                {(isRejectedSlot || isRescheduledSlot) && (
                    <div className="slot-comment">
                        <h1>Comment</h1>
                        <span>{evaluateRejectionReason}</span>
                    </div>
                )}
            </div>
            {isRejectedSupplier && (
                <>
                    <Divider style={{ margin: '0' }} />
                    <div className="supplier-rejection-comment">
                        <img src={messageGrey} />
                        {isRejectedSupplier}
                    </div>
                </>
            )}
        </div>
    );
};
